import {
  ADD_PAYMENT_REQUEST_REQUEST,
  ADD_PAYMENT_REQUEST_SUCCESS,
  ADD_PAYMENT_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  FETCH_PAYMENT_REQUESTS_REQUEST,
  FETCH_PAYMENT_REQUESTS_SUCCESS,
  FETCH_PAYMENT_REQUESTS_FAILURE,
  UPDATE_PAYMENT_REQUEST_REQUEST,
  UPDATE_PAYMENT_REQUEST_SUCCESS,
  UPDATE_PAYMENT_REQUEST_FAILURE,
  DELETE_PAYMENT_REQUEST_REQUEST,
  DELETE_PAYMENT_REQUEST_SUCCESS,
  DELETE_PAYMENT_REQUEST_FAILURE,
  CLEAR_PAYMENT_REQUESTS_ERROR,
  FETCH_PAYMENT_REQUEST_DETAILS_REQUEST,
  FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS,
  FETCH_PAYMENT_REQUEST_DETAILS_FAILURE,
  SUBMIT_PAYMENT_REQUEST_REQUEST,
  SUBMIT_PAYMENT_REQUEST_SUCCESS,
  SUBMIT_PAYMENT_REQUEST_FAILURE,
  FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST,
  FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS,
  FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  FETCH_RECEIPT_REQUEST,
  FETCH_RECEIPT_SUCCESS,
  FETCH_RECEIPT_FAILURE,
  FETCH_SUPPORTING_DOCUMENT_REQUEST,
  FETCH_SUPPORTING_DOCUMENT_SUCCESS,
  FETCH_SUPPORTING_DOCUMENT_FAILURE,
} from "../actions/paymentRequestActionTypes";

const initialState = {
  paymentRequests: [],
  paymentRequestDetails: null,
  paymentRequestVouchers: null,
  receipt: null,
  supportingDocument: null,
  isLoading: false,
  errors: {
    addPaymentRequest: null,
    approve: null,
    attest: null,
    verify: null,
    reject: null,
    pay: null,
    query: null,
    fetchPaymentRequests: null,
    fetchPaymentRequestDetails: null,
    fetchPaymentRequestVouchers: null,
    updatePaymentRequest: null,
    deletePaymentRequest: null,
    uploadReceipt: null,
    submit: null,
    fetchReceipt: null,
    fetchSupportingDocument: null,
  },
};

const paymentRequestReducer = (state = initialState, action) => {

  switch (action.type) {
    case ADD_PAYMENT_REQUEST_REQUEST:
    case FETCH_PAYMENT_REQUESTS_REQUEST:
    case FETCH_PAYMENT_REQUEST_DETAILS_REQUEST:
    case UPDATE_PAYMENT_REQUEST_REQUEST:
    case DELETE_PAYMENT_REQUEST_REQUEST:
    case ADD_APPROVE_REQUEST_REQUEST:
    case ADD_ATTEST_REQUEST_REQUEST:
    case ADD_VERIFY_REQUEST_REQUEST:
    case ADD_REJECT_REQUEST_REQUEST:
    case ADD_PAY_REQUEST_REQUEST:
    case ADD_QUERY_REQUEST_REQUEST:
    case ADD_COMMENT_REQUEST_REQUEST:
    case SUBMIT_PAYMENT_REQUEST_REQUEST:
    case FETCH_PAYMENT_REQUEST_VOUCHERS_REQUEST:
    case UPLOAD_RECEIPT_REQUEST:
    case FETCH_RECEIPT_REQUEST:
    case FETCH_SUPPORTING_DOCUMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          [action.type.replace("_REQUEST", "").toLowerCase()]: null,
        },
      };

    case ADD_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequests: [
          ...state.paymentRequests,
          { ...action.payload, id: action.payload.id || Date.now() },
        ],
        errors: { ...state.errors, addPaymentRequest: null },
      };

    case FETCH_PAYMENT_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequests: action.payload,
        errors: { ...state.errors, fetchPaymentRequests: null },
      };

    case FETCH_PAYMENT_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequestDetails: action.payload,
        errors: { ...state.errors, fetchPaymentRequestDetails: null },
      };

    case UPDATE_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequests: state.paymentRequests.map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        paymentRequestDetails:
          state.paymentRequestDetails?.id === action.payload.id
            ? action.payload
            : state.paymentRequestDetails,
        errors: { ...state.errors, updatePaymentRequest: null },
      };

    case DELETE_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequests: state.paymentRequests.filter(
          (request) => request.id !== action.payload,
        ),
        errors: { ...state.errors, deletePaymentRequest: null },
      };

    case ADD_APPROVE_REQUEST_SUCCESS:
    case ADD_ATTEST_REQUEST_SUCCESS:
    case ADD_VERIFY_REQUEST_SUCCESS:
    case ADD_REJECT_REQUEST_SUCCESS:
    case ADD_PAY_REQUEST_SUCCESS:
    case ADD_QUERY_REQUEST_SUCCESS:
    case ADD_COMMENT_REQUEST_SUCCESS:
    case SUBMIT_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequests: state.paymentRequests.map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        paymentRequestDetails:
          state.paymentRequestDetails?.id === action.payload.id
            ? action.payload
            : state.paymentRequestDetails,
        errors: {
          ...state.errors,
          [action.type.replace("_SUCCESS", "").toLowerCase()]: null,
        },
      };

    case FETCH_PAYMENT_REQUEST_VOUCHERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequestVouchers: action.payload,
        errors: { ...state.errors, fetchPaymentRequestVouchers: null },
      };

    case FETCH_SUPPORTING_DOCUMENT_SUCCESS:

      return {
        ...state,
        isLoading: false,
        supportingDocument: action.payload,
        errors: { ...state.errors, fetchSupportingDocument: null },
      };

    case UPLOAD_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentRequestVouchers: action.payload,
        paymentRequestDetails:
          state.paymentRequestDetails?.id === action.payload.id
            ? {
              ...state.paymentRequestDetails,
              receiptFilePath: action.payload.url,
              uploadedOn: action.payload.uploadedOn,
            }
            : state.paymentRequestDetails,
        errors: { ...state.errors, uploadReceipt: null },
      };

    case FETCH_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        receipt: action.payload,
        errors: { ...state.errors, fetchReceipt: null },
      };

    case ADD_PAYMENT_REQUEST_FAILURE:
    case FETCH_PAYMENT_REQUESTS_FAILURE:
    case UPDATE_PAYMENT_REQUEST_FAILURE:
    case DELETE_PAYMENT_REQUEST_FAILURE:
    case ADD_APPROVE_REQUEST_FAILURE:
    case ADD_ATTEST_REQUEST_FAILURE:
    case ADD_VERIFY_REQUEST_FAILURE:
    case ADD_REJECT_REQUEST_FAILURE:
    case ADD_PAY_REQUEST_FAILURE:
    case ADD_QUERY_REQUEST_FAILURE:
    case ADD_COMMENT_REQUEST_FAILURE:
    case SUBMIT_PAYMENT_REQUEST_FAILURE:
    case UPLOAD_RECEIPT_FAILURE:
    case FETCH_RECEIPT_FAILURE:
    case FETCH_PAYMENT_REQUEST_VOUCHERS_FAILURE:
    case FETCH_PAYMENT_REQUEST_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          [action.type.replace("_FAILURE", "").toLowerCase()]:
            action.payload || "An error occurred.",
        },
      };

    case FETCH_SUPPORTING_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        supportingDocument: null,
        errors: {
          ...state.errors,
          fetchSupportingDocument:
            action.payload || "Failed to fetch supporting document.",
        },
      };

    case CLEAR_PAYMENT_REQUESTS_ERROR:
      return {
        ...state,
        errors: initialState.errors,
      };

    default:
      return state;
  }
};

export default paymentRequestReducer;
